const options = {
  5: "bg-rose-200/5",
  10: "bg-rose-200/10",
  25: "bg-rose-200/25",
  50: "bg-rose-200/50",
  75: "bg-rose-200/75",
  90: "bg-rose-200/90",
  100: "bg-rose-200",
};

const from = {
  5: "from-rose-200/5",
  10: "from-rose-200/10",
  25: "from-rose-200/25",
  50: "from-rose-200/50",
  75: "from-rose-200/75",
  90: "from-rose-200/90",
  100: "from-rose-200",
};

export default function getBackgroundRose200(opacity, isFrom) {
  return (isFrom ? from : options)[opacity || 100];
}
